import React from "react";
import { Box, CircularProgress } from "../../../../common/MuiImports";
import { useCustomerData } from "../../hooks/useApiData";
import CurrentPaymentMethodForm from "../../SelfcareComponents/CurrentPaymentMethodForm";

interface ChangePlanSelectedProductsProps {
  selectedProducts: any;
  venue_id: string;
}

const ChangePlanPaymentInfo: React.FC<ChangePlanSelectedProductsProps> = ({
  selectedProducts,
  venue_id,
}) => {
  const { isLoading } = useCustomerData();

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <CurrentPaymentMethodForm
        selectedProducts={selectedProducts}
        showActionButtons={true}
        venue_id={venue_id}
      />
    </Box>
  );
};

export default ChangePlanPaymentInfo;
